import { Component, inject } from '@angular/core';
import { BeneficiarioService } from 'src/app/core/services/beneficiario';
import { downloadBlobFile } from 'src/app/core/utils/downloadBlobFile';

@Component({
  selector: 'app-modal-conferencia-importacao',
  templateUrl: './modal-conferencia-importacao.component.html',
  styleUrls: ['./modal-conferencia-importacao.component.scss'],
})
export class ModalConferenciaImportacaoComponent {
  beneficiarioService = inject(BeneficiarioService);
  isLoading = false;

  baixarArquivo(): void {
    this.isLoading = true;

    this.beneficiarioService
      .exportProdutosBeneficiario()
      .subscribe((value) => {
        const blob = new Blob([value], { type: 'text/plain' });

        downloadBlobFile(blob, 'lista_beneficios.xlsx');
      })
      .add(() => {
        this.isLoading = false;
      });
  }
}
